export const i18nStore = {
    state: () => ({
        availableLanguages: [],
        allTranslationKeys: [],
        internalTranslations: {},
        addTranslationModalKeyStatus: false,
        editTranslationModalKeyStatus: false,
        currentSelectedLanguages: [],
        paginatedData: {
            currentPage: 1,
            itemsPerPage: 20,
            totalItems: -1,
        },
        search:{
            key: ""
        },
        editedKey: {
            id: null,
            key: "",
            name: "",
            description: ""
        }
    }),
    mutations: {
        setAvailableLanguages(state, payload) {
            state.availableLanguages = payload;
        },
        setAllTranslationKeys(state, keys) {
            state.allTranslationKeys = keys;
        },
        setInternalTranslations(state, data) {
            state.allTranslationKeys = data
        },
        setAddTranslationModalKeyStatus(state, status) {
            state.addTranslationModalKeyStatus = status
        },
        setEditTranslation(state, data) {
            state.editTranslationModalKeyStatus = true
            state.editedKey = data;
        },
        hideEditTranslation(state) {
            state.editTranslationModalKeyStatus = false;
            state.editedKey = {
                id: null,
                key: "",
                name: "",
                description: ""
            };
        }
    }
}